/**
 * pdp.js
 * Runs ONLY on product pages.
 * Requires jQuery to be available (already load it on product pages).
 */

(function () {
  // Safety: only on PDP
  if (!document.documentElement.classList.contains('template-product')) {
    // Dawn usually has this class. If not present, fallback:
    // if (window.location.pathname.indexOf('/products/') !== 0) return;
  }

  // --- STOP scroll jump on variant option click (color/size) ---
  // Fix: do NOT block scroll on mobile swipe (cancel lock if finger moves)
  (function () {
    let lockY = null
    let lockUntil = 0
    let rafId = null

    let startX = 0
    let startY = 0
    let moved = false
    const MOVE_TOLERANCE = 10

    const isVariantArea = (target) => {
      const inVariant =
        target.closest('.color_picker_redirect_container') ||
        target.closest('.variant-picker') ||
        target.closest('variant-radios') ||
        target.closest('variant-selects')

      if (!inVariant) return false
      if (target.closest('button, a, input[type="number"]')) return false
      return true
    }

    function startLock() {
      lockY = window.scrollY
      lockUntil = Date.now() + 700

      if (rafId) cancelAnimationFrame(rafId)

      const tick = () => {
        if (lockY == null) return
        if (Date.now() > lockUntil) {
          lockY = null
          return
        }
        if (!moved && window.scrollY !== lockY) window.scrollTo(0, lockY)
        rafId = requestAnimationFrame(tick)
      }

      tick()
    }

    function stopLock() {
      lockY = null
      lockUntil = 0
      if (rafId) cancelAnimationFrame(rafId)
      rafId = null
    }

    document.addEventListener(
      'pointerdown',
      (e) => {
        if (!isVariantArea(e.target)) return

        moved = false
        startX = e.clientX || 0
        startY = e.clientY || 0

        startLock()
      },
      true
    )

    document.addEventListener(
      'pointermove',
      (e) => {
        if (lockY == null) return

        const x = e.clientX || 0
        const y = e.clientY || 0

        if (
          Math.abs(x - startX) > MOVE_TOLERANCE ||
          Math.abs(y - startY) > MOVE_TOLERANCE
        ) {
          moved = true
          stopLock()
        }
      },
      true
    )

    document.addEventListener(
      'focusin',
      () => {
        if (lockY == null) return
        if (Date.now() > lockUntil) return
        if (!moved) window.scrollTo(0, lockY)
      },
      true
    )
  })()

  // ---------- CART helpers (PDP upsell checkbox etc.) ----------
  async function updateCartSections() {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Gift-Sync': '1',
        },
        cache: 'no-store',
        body: JSON.stringify({
          updates: {},
          sections: ['cart-drawer', 'cart-icon-bubble'],
        }),
      })

      const cartData = await res.json()

      const drawer = document.querySelector('cart-drawer')
      if (drawer?.renderContents) drawer.renderContents(cartData)

      const drawerRoot = document.querySelector('cart-drawer.drawer')
      if (drawerRoot) {
        drawerRoot.classList.toggle('is-empty', cartData.item_count == 0)
      }
    } catch (error) {
      console.error('[PDP] Error updating cart sections:', error)
    }
  }

  async function addProductToCart(variantId, quantity = 1) {
    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Gift-Sync': '1' },
        cache: 'no-store',
        body: JSON.stringify({ id: variantId, quantity }),
      })

      if (!addResponse.ok) {
        console.error(`[PDP] Failed to add product variant: ${variantId}`)
        return
      }

      await addResponse.json()
      await updateCartSections()
      document.body.dispatchEvent(new Event('cart:updated'))
    } catch (e) {
      console.error('[PDP] addProductToCart error', e)
    }
  }

  async function updateProductQuantity(itemKey, quantity) {
    try {
      const changeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        cache: 'no-store',
        body: JSON.stringify({ id: itemKey, quantity }),
      })

      if (!changeResponse.ok) {
        console.error(`[PDP] Failed to update product quantity`)
        return
      }

      await changeResponse.json()
      await updateCartSections()
      document.body.dispatchEvent(new Event('cart:updated'))
    } catch (e) {
      console.error('[PDP] updateProductQuantity error', e)
    }
  }

  async function removeProductFromCart(variantId) {
    try {
      const cartResponse = await fetch('/cart.js', { cache: 'no-store' })
      const cartData = await cartResponse.json()

      const itemToRemove = cartData.items?.find(
        (item) => String(item.variant_id) === String(variantId)
      )

      if (itemToRemove) {
        await updateProductQuantity(itemToRemove.key, 0)
      } else {
        await updateCartSections()
      }
    } catch (e) {
      console.error('[PDP] removeProductFromCart error', e)
    }
  }

  // ---------- DOMContentLoaded (PDP only features) ----------
  document.addEventListener('DOMContentLoaded', function () {
    // Make scroll restoration manual when color picker container exists 
    if (document.querySelector('.color_picker_redirect_container')) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual'
    }

    // Sticky add to cart on scroll
    if (document.querySelector('.sticky_add_to_cart') && window.jQuery) {
      jQuery(window).on('scroll', function () {
        const infoAtcTriggerEl = document.querySelector(
          '.product__info-wrapper .product-form__submit'
        )
        if (!infoAtcTriggerEl) return

        const top = infoAtcTriggerEl.getBoundingClientRect().top
        if (top <= -111) {
          jQuery('.sticky_add_to_cart').addClass('sticky-active')
        } else {
          jQuery('.sticky_add_to_cart').removeClass('sticky-active')
        }
      })
    }

    // Final countdown timer
    if (document.querySelector('.the-final-countdown')) {
      function startTimer(duration) {
        let timer = duration

        setInterval(function () {
          const minutes = String(parseInt(timer / 60, 10)).padStart(2, '0')
          const seconds = String(parseInt(timer % 60, 10)).padStart(2, '0')

          document.querySelectorAll('.the-final-countdown').forEach((el) => {
            el.textContent = `${minutes}:${seconds}`
          })

          timer = --timer < 0 ? duration : timer
        }, 1000)
      }

      startTimer(60 * 10)
    }

    // newDateTime
    if (document.querySelector('.newDateTime')) {
      function newDateTime() {
        const dateNow = new Date(
          new Date().getTime() + 7 * 24 * 60 * 60 * 1000
        ).toDateString()

        const temp = dateNow.split(' ')
        let newString = ''

        switch (temp[0]) {
          case 'Sun':
            newString = 'Sun, '
            break
          case 'Mon':
            newString = 'Mon, '
            break
          case 'Tue':
            newString = 'Tues, '
            break
          case 'Wed':
            newString = 'Wed, '
            break
          case 'Thu':
            newString = 'Thurs, '
            break
          case 'Fri':
            newString = 'Fri, '
            break
          case 'Sat':
            newString = 'Sat, '
            break
        }

        switch (temp[1]) {
          case 'Jan':
            newString += 'Jan.'
            break
          case 'Feb':
            newString += 'Feb.'
            break
          case 'Mar':
            newString += 'Mar.'
            break
          case 'Apr':
            newString += 'Apr.'
            break
          case 'May':
            newString += 'May'
            break
          case 'Jun':
            newString += 'Jun.'
            break
          case 'Jul':
            newString += 'Jul.'
            break
          case 'Aug':
            newString += 'Aug.'
            break
          case 'Sep':
            newString += 'Sep.'
            break
          case 'Oct':
            newString += 'Oct.'
            break
          case 'Nov':
            newString += 'Nov.'
            break
          case 'Dec':
            newString += 'Dec.'
            break
        }

        const day = temp[2]
        switch (day) {
          case '01':
          case '21':
          case '31':
            newString += ` ${day}st`
            break
          case '02':
          case '22':
            newString += ` ${day}nd`
            break
          case '03':
          case '23':
            newString += ` ${day}rd`
            break
          default:
            newString += ` ${day}th`
        }

        return newString
      }

      document.querySelectorAll('.newDateTime').forEach((el) => {
        el.textContent = newDateTime()
      })
    }
  })

  // ---------- jQuery ready (slick + upsells etc.) ----------
  // Only run jQuery features when jQuery exists
  if (window.jQuery) {
    jQuery(function ($) {
      // PDP Upsell product list slider
      if (document.querySelector('.pdp_upsell_product_list')) {
        $('.pdp_upsell_product_list').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          prevArrow: $('.pdp_upsell_product_list_prev'),
          nextArrow: $('.pdp_upsell_product_list_next'),
        })
      }

      // PDP upsell checkbox add/remove
      const upsellCheckboxInputList = document.querySelectorAll('.upsell_checkbox_input')
      upsellCheckboxInputList.forEach(function (el) {
        el.addEventListener('change', function () {
          const upsellVariantId = el.dataset.upsellVariantId
          if (!upsellVariantId) return

          if (el.checked) addProductToCart(upsellVariantId, 1)
          else removeProductFromCart(upsellVariantId)
        })
      })

      // PDP accordion
      if (document.querySelectorAll('.pdp_accordion_list').length > 0) {
        $('.acc_ques_wrap').on('click', function () {
          const $parent = $(this).parent()
          if ($parent.hasClass('active')) $parent.removeClass('active')
          else $parent.addClass('active').siblings().removeClass('active')
        })
      }
    })
  } else {
    console.warn('[PDP] jQuery not found. Skipping jQuery-based features in pdp.js')
  }
})()